import { motion } from "framer-motion";
import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
function Contact() {

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    rating: 5
  });

  const changeHandler = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });

  };

  const submitHandler = async (e) => {

    e.preventDefault();

    if (
      !formData.fullName ||
      !formData.email ||
      !formData.subject ||
      !formData.message
    ) {

      Swal.fire({
        icon: "warning",
        title: "Incomplete Form",
        text: "Please fill all required fields."
      });

      return;

    }

    try {

      setLoading(true);

      await axios.post(
        "https://ekya-backend.onrender.com/api/feedback",
        formData
      );

      Swal.fire({
        icon: "success",
        title: "Thank You ❤️",
        text: "Your feedback has been submitted successfully."
      });

      setFormData({
        fullName: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
        rating: 5
      });

    } catch (error) {

      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "Please try again."
      });

    } finally {

      setLoading(false);

    }

  };

  return (

    <div className="bg-[#F8F5F0] min-h-screen">

      {/* Hero */}

      <section className="max-w-7xl mx-auto px-6 py-20">

        <motion.div
          initial={{
            opacity: 0,
            y: 40
          }}
          animate={{
            opacity: 1,
            y: 0
          }}
        >

          <h1
            className="
              text-5xl
              md:text-6xl
              font-bold
              text-center
              text-[#2F5D50]
            "
          >
            Contact Us
          </h1>

          <p
            className="
              text-center
              text-gray-600
              mt-5
              max-w-3xl
              mx-auto
            "
          >
            Have questions, ideas, collaborations,
            or want to join our mission?
            We'd love to hear from you.
          </p>

        </motion.div>

      </section>

      {/* Main Section */}

      <section className="max-w-7xl mx-auto px-6 pb-24">

        <div className="grid lg:grid-cols-2 gap-10">

          {/* Contact Info */}

          <motion.div
            initial={{
              opacity: 0,
              x: -50
            }}
            whileInView={{
              opacity: 1,
              x: 0
            }}
            viewport={{
              once: true
            }}
            className="
              bg-white
              rounded-3xl
              p-10
              shadow-xl
            "
          >

            <h2
              className="
                text-3xl
                font-bold
                text-[#4B1D3F]
                mb-8
              "
            >
              Get In Touch
            </h2>

            <div className="space-y-8">

              <div>

                <h3
                  className="
                    text-xl
                    font-semibold
                    text-[#3D2B1F]
                  "
                >
                  Email
                </h3>

                <p className="text-gray-600 mt-2">
                 ekya.offical@gmail.com
                </p>

              </div>

              <div>

                <h3
                  className="
                    text-xl
                    font-semibold
                    text-[#3D2B1F]
                  "
                >
                  Phone 
                </h3>

                <p className="text-gray-600 mt-2">
                  +91 98174 56907 <br/>
                   +91 92577 57755
                </p>

              </div>

              <div>

                <h3
                  className="
                    text-xl
                    font-semibold
                    text-[#3D2B1F]
                  "
                >
                  Location
                </h3>

                <p className="text-gray-600 mt-2">
                  Hisar, Haryana, India
                </p>

              </div>

              <div>

                <h3
                  className="
                    text-xl
                    font-semibold
                    text-[#3D2B1F]
                  "
                >
                  Follow Us
                </h3>

                <div className="flex gap-4 mt-4">

                  <a
                    href="https://www.instagram.com/ekyaofficial?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                    className="
                      px-5
                      py-2
                      rounded-full
                      bg-[#2F5D50]
                      text-white
                    "
                  >
                    Instagram
                  </a>

                  <a
                    href="/"
                    className="
                      px-5
                      py-2
                      rounded-full
                      bg-[#B79D74]
                      text-white
                    "
                  >
                    LinkedIn
                  </a>

                </div>

              </div>

            </div>

          </motion.div>

          {/* Contact Form */}

          <motion.div
            initial={{
              opacity: 0,
              x: 50
            }}
            whileInView={{
              opacity: 1,
              x: 0
            }}
            viewport={{
              once: true
            }}
            className="
              bg-white
              rounded-3xl
              p-10
              shadow-xl
            "
          >

 <h2 className="text-3xl font-bold text-[#4B1D3F] mb-8">
  Send Feedback
</h2>

<form
  onSubmit={submitHandler}
  className="space-y-5"
>

  <input
    type="text"
    name="fullName"
    placeholder="Full Name"
    value={formData.fullName}
    onChange={changeHandler}
    className="w-full border rounded-xl p-4 outline-none"
  />

  <input
    type="email"
    name="email"
    placeholder="Email Address"
    value={formData.email}
    onChange={changeHandler}
    className="w-full border rounded-xl p-4 outline-none"
  />

  <input
    type="text"
    name="phone"
    placeholder="Phone Number"
    value={formData.phone}
    onChange={changeHandler}
    className="w-full border rounded-xl p-4 outline-none"
  />

  <input
    type="text"
    name="subject"
    placeholder="Subject"
    value={formData.subject}
    onChange={changeHandler}
    className="w-full border rounded-xl p-4 outline-none"
  />
  <div>

  <label className="font-semibold text-[#4B1D3F]">
    Rating
  </label>

  <div className="flex gap-2 mt-3">

    {[1, 2, 3, 4, 5].map((star) => (

      <button
        type="button"
        key={star}
        onClick={() =>
          setFormData({
            ...formData,
            rating: star
          })
        }
        className={`text-3xl transition-all duration-300 hover:scale-125 ${
          formData.rating >= star
            ? "text-yellow-400"
            : "text-gray-300"
        }`}
      >
        ★
      </button>

    ))}

  </div>

</div>

<textarea
  rows="5"
  name="message"
  placeholder="Share your feedback..."
  value={formData.message}
  onChange={changeHandler}
  className="
    w-full
    border
    rounded-xl
    p-4
    outline-none
    resize-none
    focus:border-[#2F5D50]
  "
/>

<motion.button

  whileHover={{
    scale: 1.03
  }}

  whileTap={{
    scale: 0.97
  }}

  disabled={loading}

  type="submit"

  className="
    w-full
    bg-[#2F5D50]
    text-white
    py-4
    rounded-xl
    font-semibold
    shadow-lg
    transition-all
  "

>

  {loading
    ? "Submitting..."
    : "Submit Feedback ❤️"}

</motion.button>

</form>
  


          </motion.div>

        </div>

      </section>


    <section className="max-w-7xl mx-auto px-6 pb-24">

  <div
    className="
      bg-white
      rounded-3xl
      shadow-xl
      p-10
    "
  >

    <h2
      className="
        text-4xl
        font-bold
        text-center
        text-[#2F5D50]
        mb-12
      "
    >
      Why Connect With EKYA?
    </h2>

    <div className="grid md:grid-cols-3 gap-8">

      <div className="text-center">
        <div className="text-5xl mb-4">🤝</div>
        <h3 className="text-xl font-bold mb-3">
          Collaborate
        </h3>
        <p className="text-gray-600">
          Work with passionate individuals and
          organizations dedicated to positive change.
        </p>
      </div>

      <div className="text-center">
        <div className="text-5xl mb-4">🌱</div>
        <h3 className="text-xl font-bold mb-3">
          Create Impact
        </h3>
        <p className="text-gray-600">
          Participate in initiatives that directly
          benefit communities and the environment.
        </p>
      </div>

      <div className="text-center">
        <div className="text-5xl mb-4">❤️</div>
        <h3 className="text-xl font-bold mb-3">
          Make A Difference
        </h3>
        <p className="text-gray-600">
          Every contribution, no matter how small,
          helps create meaningful change.
        </p>
      </div>

    </div>

  </div>

</section>

    </div>

  );
}

export default Contact;